jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ";path=/";
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

class LocationSelector extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector(".location-selector-close").addEventListener("click", () => {
      setCookie("userSawThePanel", true, 360);
      this.togglePanelDisplay(); 
    });
    this.querySelector(".location-selector-button-leave").addEventListener("click", () => { 
      if (this.querySelector(".location-selector-button-leave").getAttribute("redirectTo")) {
        setCookie("userSawThePanel", true, 360);
        window.location.href = this.querySelector(".location-selector-button-leave").getAttribute("redirectTo");
      } else {
        setCookie("userSawThePanel", true, 360);
        this.togglePanelDisplay();
      }
    });
    this.querySelector(".location-selector-button-choose").addEventListener("click", () => { 
      this.toggleCountryListDisplay();
    });
    this.querySelector(".location-selector-countries-close").addEventListener("click", () => {
      this.toggleCountryListDisplay();
    })
    this.querySelectorAll(".location-selector-country").forEach((element) => {
      element.addEventListener("click", () => {
        if (element.getAttribute("redirectTo")) {
          setCookie("userSawThePanel", true, 360);
          window.location.href = element.getAttribute("redirectTo");
        } else {
          setCookie("userSawThePanel", true, 360);
          this.toggleCountryListDisplay();
          this.togglePanelDisplay();
        }
      });
    });
    if (document.querySelector(".custom-location-selector-wrapper")) {
      document.querySelector(".custom-location-selector-wrapper").addEventListener("click", () => {
        this.toggleCountryListDisplay();
        this.querySelector(".location-selector-country-list-wrapper").style.top = "0px";
        this.querySelector(".location-selector-country-list-wrapper").style.bottom = "unset";
      });
    }
    
    this.checkForCookie();
    
  }
   checkForCookie() {
    if (!sessionStorage.getItem("redirectedCountry") || window.location.href.includes("redirected=")) {
      fetch(
        "/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&currency[enabled]=true&currency[exclude]=HUF",
        {
          headers: {
            accept: "/",
            "accept-language": "en-US;q=0.8,en;q=0.7",
            "sec-ch-ua":
            '"Not.A/Brand";v="8", "Chromium";v="114", "Google Chrome";v="114"',
            "sec-ch-ua-mobile": "?0",
            "sec-ch-ua-platform": '"macOS"',
            "sec-fetch-dest": "empty",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
          },
          referrer: "https://hu.sugarbird.com/",
          referrerPolicy: "strict-origin-when-cross-origin",
          body: null,
          method: "GET",
          mode: "cors",
          credentials: "include",
        }
      )
      .then((resp) => resp.json())
      .then((data) => {
          let currentCountryHandle = data.detected_values.country.handle;
          let currentCountryName = data.detected_values.country.name;

          // let cookieData = currentCountryHandle + "," + currentCountryName;
          // setCookie("savedCountryData", cookieData, 30);

          this.handleUI(currentCountryHandle, currentCountryName);
                
        });
      }  else {
          this.changeCurrentCountry(sessionStorage.getItem("redirectedCountry"));
      } 
   } 

  handleUI(countryHandle, countryName) {
    this.querySelectorAll(".location-selector-country").forEach((element) => {
            if (element.getAttribute("country") == countryHandle)
              countryName = element.textContent;
          })

    // Overwrite the UI when user come shere by manually choosing a country
    if (window.location.href.includes("redirected=")) {
        let urlParams = new URLSearchParams(window.location.search);
        let manuallySelectedCountry = urlParams.get("redirected");
        console.log(manuallySelectedCountry);
        this.querySelectorAll(".location-selector-country").forEach((element) => {
          if (element.getAttribute("country") == manuallySelectedCountry) {
            countryName = element.textContent;
            sessionStorage.setItem("redirectedCountry", element.textContent)
          }
        })
    }

    if (sessionStorage.getItem("redirectedCountry"))
      countryName = sessionStorage.getItem("redirectedCountry")
  
    // This function checks, if the user is coming from a country where we ship to or not
    this.querySelectorAll(".location-selector-country").forEach((element) => {
        if (countryHandle == element.getAttribute("country")) {
          this.querySelector(".location-selector-button-leave").style.display = "block";
          if (element.getAttribute("redirectTo")) {
            this.querySelector("#location-selector-current-text").textContent = "Ez a weboldal nem szállít ";
            this.querySelector(".location-selector-button-leave").setAttribute("redirectTo", element.getAttribute("redirectTo"));
          }
        }
    });
    this.changeCurrentCountry(countryName);

    // The user was redirected once, we prevent infinite redirect loop
    if (getCookie("userWasRedirected")) {
      return;
    }
    
    if (window.location.href.includes("showpanel=")) {
      setCookie("userWasRedirected", true, 1);
    }

    // A felhasználó jó helyre jött, ezért csak akkor dobjuk fel, ha még nem válaszolt.
    if (countryHandle == "HU") {
      // A felhasználó a boltválasztó által jött => semmiképp se mutassa
      if (window.location.href.includes("redirected=")) {
        setCookie("userSawThePanel", true, 360);
      // A felhasználót automatán irányítottuk ide => Ha járt már itt, akkor ne mutassa
      } else if (window.location.href.includes("autoredirect=true")) {
        if (!getCookie("userSawThePanel")) {
          this.togglePanelDisplay();
        }
      // A felhasználó rossz url-re jött => Ha járt már itt, akkor ne legyen semmi.
      } else {
        if (!getCookie("userSawThePanel")) {
          this.togglePanelDisplay();
        }
      }
    } else if (!sessionStorage.getItem("userWantsToStay")) {
      if (window.location.href.includes("redirected=")) {
        sessionStorage.setItem("userWantsToStay", true);
      } else if (!window.location.href.includes("myshopify")) {
        // Megpróbáljuk megnézni, hogy létezik-e olyan ország átirányító linkkel, amiből a felhasználó jött
        // Ha nem, akkor mindenképp az angolra irányítjuk
        let autoRedirectUrl = document.querySelector("location-selector .location-selector-country[country='" + countryHandle + "']")?.getAttribute("redirectto");
        if (autoRedirectUrl)
          window.location.href = autoRedirectUrl.split("?")[0] + "?showpanel=true";
        else
          window.location.href = "https://sugarbird.com/?showpanel=true";
      }
    }
  }
    
  togglePanelDisplay() {
    document.querySelector(".location-selector").classList.toggle("location-selector-hidden");
  }

  toggleCountryListDisplay() {
    // Use this to hide elements when the country selector is opened
    document.body.classList.toggle("location-selector-active");
    document.querySelector(".location-selector-country-list-wrapper").classList.toggle("location-selector-hidden");
  }

  changeCurrentCountry(countryName) {
    document.querySelector("#location-selector-current-country").textContent = countryName;
    document.querySelector(".location-selector-button-leave").textContent = countryName;
    document.querySelector("#currentCountry").textContent = countryName;
  }
  
}

customElements.define("location-selector", LocationSelector);

function nocontext(e) {
      var clickedTag = (e==null) ? event.srcElement.tagName : e.target.tagName;
          return false;
      }
document.oncontextmenu = nocontext;